import RotateLoader from "react-spinners/RotateLoader";

const Loader = () => {
    return (
        <div className="position-fixed top-0 bottom-0 start-0 end-0 d-flex align-items-center justify-content-center" style={{ zIndex: 99999 }}>
            <RotateLoader
                color={`#04c060`}
                aria-label="Loading Spinner"
                data-testid="loader"
            />
        </div>
    )
}

export default Loader;